var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"qr-card"}),_c('qriously',{ref:"qrcode",staticStyle:{"display":"none"},attrs:{"value":_vm.studentId,"size":120,"level":"L"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }